import moment from 'moment';

export class User {
  id: number;
  login_id: string;
  name: string;
  role: string;
  curriculum_id: string;
  email: string;
  birthday: string;
  login_count: number;
  login_failed_count: number;
  last_login_at: string;
  is_active: boolean;
  is_active_cache: boolean;
  curriculums: Curriculum[] = new Array<Curriculum>();
  is_password_checked: boolean = false
  is_delete_checked: boolean = false
  is_login_failed_checked: boolean = false
  jsonUserCache: string
  subject_codes: string[]
  school_subjects: SchoolSubject[] = []

  constructor(user: any, curriculums: any[], schoolSubjects: any[]){
    this.id = user.id;
    this.login_id = user.login_id;
    this.name = user.name;
    this.role = user.role;
    this.curriculum_id = user.curriculum_id;
    this.email = user.email;
    this.birthday = user.birthday ? moment(user.birthday).format('YYYY-MM-DD') : null;
    this.login_count = user.login_count;
    this.login_failed_count = user.login_failed_count;
    this.last_login_at = user.last_login_at;
    this.is_active = user.is_active;
    this.is_active_cache = user.is_active;
    this.subject_codes = user.subject_codes;

    if(this.curriculum_id){
      const curriculumIds = this.curriculum_id.split(",");
      curriculums.forEach((x: any) => {
        const is_selected = curriculumIds.includes(`${x.id}`);
        this.curriculums.push(new Curriculum(x, is_selected));
      });
    }else{
      curriculums.forEach((x: any) => {
        this.curriculums.push(new Curriculum(x, false));
      });
    }

    if(this.subject_codes){
      schoolSubjects.forEach((x: any) => {
        const is_selected = this.subject_codes.includes(`${x.subject_code}`);
        this.school_subjects.push(new SchoolSubject(x, is_selected));
      });
    }else{
      schoolSubjects.forEach((x: any) => {
        this.school_subjects.push(new SchoolSubject(x, false));
      });
    }
  }
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }
}

export class SchoolSubject {
  subject_code: number
  name: string
  is_selected: boolean

  constructor(x: any, is_selected: boolean){
    this.subject_code = x.subject_code;
    this.name = x.name;
    this.is_selected = is_selected;
  }
}